import { render, staticRenderFns } from "./SliderNews.vue?vue&type=template&id=1b90995a&"
import script from "./SliderNews.vue?vue&type=script&lang=js&"
export * from "./SliderNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports